import { Injectable, inject } from '@angular/core';
import { type Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import type { AgendaItemModel } from '../models/middleware/agenda-item.model';
import {
  type EventType,
  type EventWithAgendaItems,
  isEventWithAgendaField,
} from '../models/middleware/event-item.model';
import { EventService } from './event.service';

@Injectable({
  providedIn: 'root',
})
export class AgendaService {
  private readonly eventService = inject(EventService);

  public getAgendaItems<T extends EventType>(documentId: string, eventType: T): Observable<AgendaItemModel[]> {
    const currentEvent = this.eventService.getCurrentEvent();
    if (currentEvent && currentEvent.documentId === documentId && isEventWithAgendaField(currentEvent)) {
      return of((currentEvent as EventWithAgendaItems<EventType>).agenda);
    } else {
      return this.eventService.getEvent(documentId, eventType).pipe(
        tap((event) => this.eventService.setCurrentEvent(event)),
        map((response) => {
          return isEventWithAgendaField(response) ? response.agenda : [];
        })
      );
    }
  }
}
